import React from "react";
import PropTypes from "prop-types";
import omit from "lodash/omit";
import get from "lodash/get";
import parse5 from "parse5";
import translations from "../locales";

class TranslatedText extends React.PureComponent {
  static propTypes = {
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    values: PropTypes.shape({}),
    translateKey: PropTypes.string.isRequired,
  };

  static defaultProps = {
    as: "div",
    values: {},
  };

  parseStyleString = (s) =>
    s.split(";").reduce(function (ruleMap, ruleString) {
      const rulePair = ruleString.split(":");
      ruleMap[rulePair[0].trim()] = rulePair[1].trim();

      return ruleMap;
    }, {});

  render() {
    const textProps = omit(this.props, ["as", "translateKey", "values"]);
    const text = translations.formatString(get(translations, this.props.translateKey), this.props.values);

    if (!text) {
      console.log("missing translate key", this.props.translateKey);
      return null;
    }
    return React.createElement(
      this.props.as,
      textProps,
      <React.Fragment>
        {parse5.parseFragment(text).childNodes.map((node) => {
          if (!node.childNodes) {
            return node.value;
          }
          const nodeStyleString = get(
            node.attrs.find((attr) => attr.name === "style"),
            "value",
            null
          );
          const nodeHrefString = get(
              node.attrs.find((attr) => attr.name === "href"),
              "value",
              null
          );

          return React.createElement(
            node.tagName || "span",
            { style: nodeStyleString ? this.parseStyleString(nodeStyleString) : {}, ...(nodeHrefString ? {href: nodeHrefString} : {}) },
            node.childNodes.map((child) => child.value)
          );
        })}
      </React.Fragment>
    );
  }
}

export default TranslatedText;
